import { Component, Input } from '@angular/core';
import { Constant, RoleName } from 'src/app/@shared/constants/Constant';
import { ReportService } from 'src/app/service/report.service';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { IInvoiceStatusReportSorting, IServerResponseInvoiceStatusResponseModel } from './invoice-status-report.model';
import { Subscription } from 'rxjs';
import { filterInvoiceStatusReport } from 'src/app/service/filterData.model';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-invoice-status-report',
  templateUrl: './invoice-status-report.component.html',
  styleUrls: ['./invoice-status-report.component.css']
})
export class InvoiceStatusReportComponent {

  @Input("filterInvoiceStatusReport") filterInvoiceStatusReport: filterInvoiceStatusReport;
  @Input("searchText") searchText: string;

  private _subscriptions: Subscription = new Subscription();
  invoiceStatusReportData: IServerResponseInvoiceStatusResponseModel;
  public loader: boolean = false;
  public timeZone: any;
  public currentPage: number = 1;
  public pageSize: number = 10;
  public itemsPerPage: number = 10;
  public paginationText: string;
  public nextLabel: any;
  public previousLabel: any;
  public responsive: any;
  public maxDate = new Date().toISOString().slice(0, 16);
  public sortBy: string;
  public sortOrder: boolean;
  public invoiceStatusReportSorting: IInvoiceStatusReportSorting;
  public user: ILoggedInUserViewModel;
  public isInternalReadOnly: boolean = false;
  public itineraryPageRedirectUrl = `${environment.redirectURL}`;

  constructor(
    private _reportService: ReportService,
    private _serviceRequestService: ServiceRequestService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
    this._subscriptions.add(this._serviceRequestService.timZoneChange.subscribe(() => {
      this.timeZone = Constant.selectedTimeZoneShortValue;
    }));
  }

  ngOnInit() {
    this.initializeInvoiceStatusReportSorting();
    this.getInvoiceStatusReportData();
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  initializeInvoiceStatusReportSorting() {
    this.sortBy = "requestedOn";
    this.sortOrder = true;
    this.invoiceStatusReportSorting = {
      tripId: false,
      requestedBy: false,
      requestedOn: false,
      invoiceStatus: false,
      invoiceFailureReason: false,
      ServiceRequestGroupInvoiceId: false
    };
  }

  public getInvoiceStatusReportData() {
    this.loader = true;
    this.filterInvoiceStatusReport.offsetValue = this.currentPage;
    this.filterInvoiceStatusReport.limit = this.itemsPerPage;
    if(this.user?.role == RoleName.Accounting)
    {
      this._subscriptions.add(this._reportService.fetchInvoiceStatusReport(this.filterInvoiceStatusReport).subscribe((response: IServerResponseInvoiceStatusResponseModel) => {
        this.loader = false;
        this.invoiceStatusReportData = response;
        this.initializeInvoiceStatusReportSorting();
        this.updatePaginationText(false);
      }, (error) => {
        this.loader = false;
        console.log(error);
      }));
    }
  }

  public updatePaginationText(updatePagination: boolean) {
    this.paginationText = Constant.showPaginationMessage(this.invoiceStatusReportData?.totalRecords, this.currentPage, this.itemsPerPage);
    updatePagination ? this.getInvoiceStatusReportData() : null;
  }

  public updateItemsPerPage(response) {
    this.currentPage = 1;
    this.itemsPerPage = Number(response);
  }
}
